<template>
  <div class="CiteScore" v-if="tableData && tableData.length">
    <div class="CiteScore_box">
      <div class="CiteScore_box_left">
        <div>
          <p class="CiteScore_box_left_title">CiteScore</p>
          <p>( <span>{{ tableData[0].version }}</span> )</p>
        </div>
      </div>
      <div class="CiteScore_box_right">
        <el-table
          class="CiteScore_box_right_table"
          border
          v-if="tableData.length"
          :data="[tableData[0]]"
        >
          <el-table-column label="CiteScore" width="100" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.citeScore }}</div>
            </template>
          </el-table-column>
          <el-table-column label="SJR" width="100" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.sjr }}</div>
            </template>
          </el-table-column>
          <el-table-column label="SNIP" width="100" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.citeScore }}</div>
            </template>
          </el-table-column>
          <el-table-column label="CiteScore排名" align="center">
            <template slot-scope="scope">
              <el-table
                class="tableNoBorder"
                v-if="tableData.length"
                :data="tableData"
              >
                <el-table-column label="学科" width="200">
                  <template slot-scope="scope">
                    <div>
                      <p>大类：{{ scope.row.subjectCategory }}</p>
                      <p>小类：{{ scope.row.subjectSubCategory }}</p>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="分区" width="40">
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.partition }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="排名" width="50">
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.rank + "/" + scope.row.journalNumber }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="百分比" width="100">
                  <template slot-scope="scope">
                    <div style="text-align: center;padding:0 20px;">
                      {{ scope.row.percentile }}
                      <el-progress
                        color="#5FB878"
                        :show-text="false"
                        :percentage="parseInt(scope.row.percentile)"
                      ></el-progress>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GetCiteScoreRank } from "@/api/analysis";
export default {
  name: "CiteScore",
  computed: {
    ...mapGetters({
      magId: "magId"
    })
  },
  data() {
    return {
      tableData: []
    };
  },
  created() {
    this.GetCiteScoreRank();
  },
  methods: {
    GetCiteScoreRank() {
      let params = {
        magId: this.magId
      };
      GetCiteScoreRank(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          this.tableData = res.data.data;
          console.log(this.tableData, "tableData");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.CiteScore {
  text-align: left;
  &_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #e2e2e2;
    &_left {
      padding: 0 20px;
      min-width: 15%;
      max-width: 15%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      &_title {
        display: flex;
        align-items: center;
        i {
          color: #FFABAA;
          font-size: 20px;
          cursor: pointer;
          margin-left: 5px;
        }
      }
      p {
        font-size: 14px;
        color: #333;
        margin-bottom: 5px;
        font-weight: bolder;
        span {
          color: red;
        }
      }
    }
    &_right {
      padding: 20px;
      border-left: 1px solid #e2e2e2;
      overflow: hidden;
      &_table {
        width: 100%;
        color: #666;
        /deep/ th.el-table__cell {
          background: #f6f6f6 !important;
        }
      }
      .tableNoBorder {
        color: #333;
        /deep/ th.el-table__cell {
          background: transparent !important;
        }
        /deep/ .el-table--border th {
          border: none !important;
        }
        .editLink {
          color: #2e9aff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
